// extracted by mini-css-extract-plugin
module.exports = {"container":"AvatarPageTitleWrapper_container__1hkFL"};